import { LOGO_URL } from "@/lib/api";
import { Link } from "react-router-dom";

export const Logo = ({ size = 56, withText = false, to = "/", className = "" }) => {
  const content = (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="canto-logo">
      <img
        src={LOGO_URL}
        alt="Canto Dei"
        style={{ width: size, height: size }}
        className="object-contain"
      />
      {withText && (
        <span className="flex flex-col leading-none">
          <span className="font-serif text-2xl text-gold tracking-wide">Canto Dei</span>
          <span className="text-[10px] tracking-[0.3em] text-muted-foreground uppercase mt-0.5">
            Song of the Gods
          </span>
        </span>
      )}
    </span>
  );
  if (to) {
    return (
      <Link to={to} aria-label="Canto Dei Startseite">
        {content}
      </Link>
    );
  }
  return content;
};
